import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 20,
	viewBox: "0 0 23 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Icon",
		d: "M15.8235 1.49528C17.3924 2.27494 18.4706 3.89391 18.4706 5.76471C18.4706 7.6355 17.3924 9.25447 15.8235 10.0341M17.9412 15.5762C19.5415 16.3004 20.9827 17.4806 22.1765 19M1 19C3.06099 16.3768 5.85913 14.7647 8.94118 14.7647C12.0232 14.7647 14.8214 16.3768 16.8824 19M13.7059 5.76471C13.7059 8.39618 11.5727 10.5294 8.94118 10.5294C6.3097 10.5294 4.17647 8.39618 4.17647 5.76471C4.17647 3.13323 6.3097 1 8.94118 1C11.5727 1 13.7059 3.13323 13.7059 5.76471Z",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPeople;
